export const Indeed = "https://www.indeed.com/jobs?q=Stepping+Stones+Academy&l=Fort+Worth%2C+TX&filter=0&vjk=5518a654aa6bde60"